<template>
    <div id="user-auth">
        <transition name="fade" mode="out-in" appear :duration="500">
            <ul>
                <template v-if="$store.getters['user/account']">
                    <li
                        class="my-account-item icon-item wt-md uc icon-element interactive"
                        @click="showAccountPanel"
                    >
                        <svg-icon id="signedIn"></svg-icon>
                        <span class="mobile-only">Your Account</span>
                        <span
                            class="action-required"
                            v-if="
                                !$store.getters['user/stripeConnectIsOnboarded']
                            "
                        ></span>
                    </li>
                </template>
                <template v-else>
                    <li class="wt-md uc interactive" @click="openLoginPanel">
                        <span class="button auth-btn"
                            >Log In / Join</span
                        >
                    </li>
                </template>
            </ul>
        </transition>
    </div>
</template>

<script>
export default {
    methods: {
        showAccountPanel() {
            if (!window.location.href.includes("#my-account")) {
                window.history.pushState(
                    "state obj or string",
                    "url",
                    window.location.href + "#my-account"
                );
            }
            this.$store.dispatch("account/commitMutation", {
                mutation: "open",
                data: this.$store.getters["user/shouldCompleteProfile"],
            });
        },
        openLoginPanel() {
            if (!window.location.href.includes("#login")) {
                window.history.pushState(
                    "state obj or string",
                    "url",
                    window.location.href + "#login"
                );
            }
            this.$store.commit("user/changeAuthMode", "login");
        },
        openSignupPanel() {
            if (!window.location.href.includes("#sign-up")) {
                window.history.pushState(
                    "state obj or string",
                    "url",
                    window.location.href + "#sign-up"
                );
            }
            this.$store.commit("user/changeAuthMode", "signup");
        },
    },
    computed: {
        user() {
            return this.$store.state["user"];
        },
    },
};
</script>
